import {useState, useEffect} from 'react'
import compose from 'recompose/compose'
import withDistricts from '@/lib/hoc/withDistricts'
import withRestoredScroll from '@/lib/hoc/withRestoredScroll'
import {getCitiesWithDistricts} from '@/lib/cities'
import logger from '@/lib/logger'
import {getCityPreposition} from '@/lib/cities'
import HeadHelmet from '@/components/shared/HeadHelmet'
import Shell from '@/components/layout/templates/Default'
import LandingSection from '@/components/shared/LandingSection'
import Anchor from '@/components/shared/Anchor'
import Spinner from '@/components/layout/Spinner'
import sitemapStyles from '@/styles/organisms/Sitemap/styles.module.css'
import composesStyles from '@/styles/_settings/composes.module.css'
import resultStyles from '@/styles/molecules/Result/styles.module.css'

const SiteMap = ({districts}) => {
  const [pages, setPages] = useState()

  function definePages() {
    const cities = Object.entries(getCitiesWithDistricts(districts)).map(
      (item) => {
        return {
          label: `Comprar imóvel ${
            item[1].citySlug === 'rio-de-janeiro' ? 'no' : 'em'
          } ${item[1].city}`,
          title: `Compre seu imóvel ${getCityPreposition(item[1].citySlug)} ${
            item[1].city
          }`,
          to: `/imoveis/${item[1].stateSlug}/${item[1].citySlug}`,
          subnav: item[1].districts.map((item) => {
            return {
              label: item.name,
              title: `Comprar imóvel: Imóveis em ${item.name}`,
              to: `/imoveis/${item.stateSlug}/${item.citySlug}/${item.nameSlug}`
            }
          })
        }
      }
    )

    const sitemapPages = [
      {
        label: 'Página incial',
        title: 'Ir para a página incial',
        to: '/'
      },
      {
        label: 'Comprar imóvel',
        title: 'Compre seu imóvel',
        to: '/imoveis'
      },
      ...cities,
      {
        label: 'Vender',
        title: 'Venda seu imóvel',
        to: '/vender'
      },
      {
        label: 'Avalie seu imóvel',
        title: 'Avalie seu imóvel',
        to: '/avaliar'
      },
      {
        label: 'Imóveis para você',
        title: 'Seu perfil na EmCasa',
        to: '/voce'
      },
      {
        label: 'Programa Corretor Parceiro',
        title: 'Junte-se a rede de corretores parceiros da EmCasa',
        to: '/corretor-parceiro',
        subnav: [
          {
            label: 'Cadastrar',
            title: 'Cadastro para o Programa Corretor Parceiro',
            to: '/corretor-parceiro/cadastrar'
          },
          {
            label: 'Indicar',
            title: 'Indicação de imóvel para o Programa Corretor Parceiro',
            to: '/corretor-parceiro/indicar'
          }
        ]
      },
      {
        label: 'Política de cookies',
        title: 'Política de privacidade e termos de uso da EmCasa',
        to: '/legal'
      }
    ]

    setPages(sitemapPages)
  }

  function handleLinkClick(url) {
    logger.action('sitemap-link', {url: url})
  }

  useEffect(() => {
    logger.action('sitemap-page')
  }, [])

  useEffect(() => {
    if (districts) {
      definePages()
      logger.action('sitemap-page-districts')
    }
  }, [districts])

  return (
    <Shell>
      <HeadHelmet
        title="Mapa do Site | EmCasa"
        description="A EmCasa te ajuda a encontrar Apartamentos à Venda com tecnologia e um time de especialistas, tornando a compra de um imóvel mais transparente, ágil e segura."
        url={'https://emcasa.com/sitemap'}
        image={`${process.env.CLOUDINARY_IMAGE_URL}/share/share-3`}
      />
      <div className={composesStyles.fullmaxwidth}>
        {pages && pages.length ? (
          <LandingSection
            label="Mapa do Site"
            contents={[
              <ul className={sitemapStyles.ecSitemap}>
                {pages.map((item) => {
                  return (
                    <li
                      key={item.title}
                      className={sitemapStyles.ecSitemap__item}
                    >
                      <Anchor
                        to={{pathname: item.to, state: {scroll: 0}}}
                        href={item.href}
                        target={item.target}
                        title={item.title}
                        className={sitemapStyles.ecSitemap__link}
                        onClick={() => handleLinkClick(item.to || item.href)}
                      >
                        {item.label}
                      </Anchor>
                      {item.subnav ? (
                        <ul className={sitemapStyles.ecSitemap__list}>
                          {item.subnav.map((subitem, subindex) => (
                            <li
                              key={subindex}
                              className={sitemapStyles.ecSitemap__item}
                            >
                              <Anchor
                                to={{pathname: subitem.to, state: {scroll: 0}}}
                                href={subitem.href}
                                target={subitem.target}
                                title={subitem.title}
                                className={sitemapStyles.ecSitemap__link}
                                onClick={() =>
                                  handleLinkClick(subitem.to || subitem.href)
                                }
                              >
                                {subitem.label}
                              </Anchor>
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </li>
                  )
                })}
              </ul>
            ]}
          />
        ) : (
          <div className={resultStyles.ecTemplateListings__result}>
            <Spinner />
          </div>
        )}
      </div>
    </Shell>
  )
}

export default compose(withDistricts, withRestoredScroll)(SiteMap)
